import isEqual from "lodash/isEqual";
export function isString(x) {
    return typeof x === "string";
}
export const arePropsEqual = (prevProps, nextProps) => {
    return isEqual(prevProps, nextProps);
};
export const filterObjectByKeys = (raw, allowed) => raw &&
    Object.keys(raw)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
        obj[key] = raw[key];
        return obj;
    }, {});
export const lowercaseKeys = (obj) => obj &&
    Object.keys(obj).reduce((acc, key) => {
        acc[key.toLowerCase()] = obj[key];
        return acc;
    }, {});
export const lowercased = (arr) => arr?.map((x) => x.toLowerCase());
export const objectHasKey = (obj, key) => Object.keys(obj).some((k) => k === key);
export const randomElementFromArray = (arr) => arr[Math.floor(Math.random() * arr.length)];
export const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
        // @ts-ignore
        result.push(i);
    }
    return result;
};
//# sourceMappingURL=utils.js.map